export default import.meta.ROLLDOWN_FILE_URL_e7QL0MfS0eB1H0TdFd7NwQ